export const COLLECTION_ACTIONS = {
	STORE_COLLECTIONS: 'COLLECTION_ACTIONS_STORE',
};
